<template>
	<div>
		<div class="p_flex heades" v-show="name==1?true : false">
			<span class="type_size_18 p_m_t_10 head">题型</span>
			<div class="p_flex p_f_1 heade_center ">
				<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arr" :key='index' >
					<el-button @click="goHeaderindex(item.id)" :disabled="forbid" :type="headerindex==item.id?'success':'info'" round size="mini">{{item.name}}</el-button>
				</div>
			</div>
		</div>
		<div class="p_flex heades">
			<span class="type_size_18 p_m_t_10 head">年级</span>
			<div class="p_flex p_f_1 heade_center ">
				<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrs" :key='index' >
					<el-button @click="goHeaderindexs(item.id)" :disabled="forbid" :type="headerindexs==item.id?'success':'info'" round size="mini">{{item.name}}</el-button>
				</div>
			</div>
		</div>
		<div class="p_flex heades">
			<span class="type_size_18 p_m_t_10 head">学科</span>
			<div class="p_flex p_f_1 heade_center ">
				<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrss" :key='index' >
					<el-button @click="goHeaderindexss(item.id)" :disabled="forbid" :type="headerindexss==item.id?'success':'info'" round size="mini">{{item.name}}</el-button>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import Info from '../../../assets/js/public.js'
export default {
	props:{
		o:null,
		forbid:null
	},
	data() {
		return {
			headerList:[],
			headerindex:0,
			headerindexs:0,
			headerindexss:0,
			arr:[],
			arrs:[],
			arrss:[],
			name:1
		};
	},
	watch: {
		o:{
			handler(i,o){
				// console.log(i)
				this.name=i
			}
		}
	},
	created(){

		this.$request.ajax(this).post("/Library/questionType").then(res=>{
			// console.log(res)
			this.arr=res.data
			this.arr.unshift(...[{id:0,name:"全部"}])
		})
		this.$request.ajax(this).post("/Library/grade").then(res=>{  //年纪
			// console.log(res)
			this.arrs=res.data
			this.arrs.unshift(...[{id:0,name:"全部"}])
		})
		this.$request.ajax(this).post("/Library/subject").then(res=>{  // 学科
			// console.log(res)
			this.arrss=res.data
			this.arrss.unshift(...[{id:0,name:"全部"}])
		})
		if( this.$route.query.name  && this.$route.query.names){
			if(JSON.parse(this.$route.query.name) && JSON.parse(this.$route.query.names)){
			this.headerindexs=JSON.parse(this.$route.query.name)
			this.headerindexss=JSON.parse(this.$route.query.names)
		}
		}

	},
	mounted() {
		this.headerList = Info.English
	},
	methods: {
		goHeaderindex(i){
			this.headerindex = i
			this.$emit('Headerindex', i);
		},
		goHeaderindexs(i){
			this.headerindexs = i
			this.$emit('headerindexs',i)
		},
		goHeaderindexss(i){
			this.headerindexss = i
			this.$emit('headerindexss',i)
		}
	}
};
</script>

<style lang="scss" scoped>
.heades {
	padding: 0 0 10px;
}
.heade_center{
	flex-wrap: wrap;
}
>>>.el-button--info {
	color: #4D4D4D;
}
.head{
	// padding-top: 5px;
}
.p_m_t_10{
	margin-top: 10px;
}
>>>.el-button--mini, .el-button--mini.is-round{
	padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/mineHeader.vue